import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  // Add,
  BasicTable,
  // Button,
  // CardComponent,
  // CareNavigatorGroupCard,
  // Layers,
  NoComplianceAssurances,
  // SvgTable,
  TextField,
  // ToggleGroup,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React, { ChangeEvent, useEffect, useState } from 'react';
import Loader from '../../_components/molecules/Loader';
import {
  CareNavigatorType,
  formatCareNavigatorData,
  formatGroupsTableData,
  individualGroupsTableColumns,
} from '../../core-utils/helper-utils/careNavigatorHelper';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { observer } from 'mobx-react';
import CareNavigatorConstants from '../../core-utils/messages/CareNavigatorConstants';
import AddCareNavGroupModal from '../../_components/organisms/AddCareNavGroupModal';
import { useNavigate } from 'react-router-dom';
import { CARE_NAVIGATOR } from '../../core-utils/routes';
import axios from 'axios';
import properties from '../../core-utils/properties';
import { useStores } from '../../stores';
import DeleteGroupConfirmModal from '../../_components/organisms/DeleteGroupConfirmModal';
import {
  getCurrentTimestamp,
  getDateFromMonthAndYear,
} from '../../core-utils/helper-utils/helper';
import { toJS } from 'mobx';
import {
  SimpleSearch,
  Typography,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import GifWithLabels from '@HomaHealth/ui-component-library/lib/_patient-access-components/molecules/GIFWithLabels';
import NoResults from '../../../public/Images/NoResults.png';
import {
  formatUserAccessRoutes,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import { IEmployerGroupResponseData } from '../HomePage';
import { getSpecificDeductibleAmount } from '../../core-utils/helper-utils/specificDeductiblehHelper';

const useStyles = makeStyles()({
  root: {
    marginTop: '28px',
  },
  addNewGroupGrid: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
  },
  cards: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '24px',
  },
  seeMoreCard: {
    width: '360px',
    height: '223px',
    borderRadius: '8px',
    backgroundColor: patientAccessTheme.palette.status.white,
    boxShadow: '0px 4px 20px rgb(69 70 77 / 6%)',
    border: '1px solid ' + patientAccessTheme.palette.grey[300],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  noGroups: {
    display: 'flex',
    alignItems: 'center',
    height: '290px',
    justifyContent: 'center',
  },
  text: {
    background: patientAccessTheme.palette.grey[100],
    borderRadius: '4px',
    padding: '3px 17px',
  },
});

const CareNavigator = observer(() => {
  //Constants
  const { classes } = useStyles();
  const navigate = useNavigate();

  const careNavigatorStore = useStores().careNavigatorStore;
  const employerGroupStore = useStores().employerGroupStore;
  const loginPageStore = useStores().loginPageStore;
  const userDetailsStore = useStores().userDetailsStore;

  const messages = CareNavigatorConstants;
  // const options: string[] = ['Delete'];

  //States

  const [pageSize] = useState<number>(5);
  const [pageCount, setPageCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [CareNavigatorsGroups, setCareNavigatorGroups] = useState<
    CareNavigatorType[]
  >([]);
  const [filteredData, setFilteredData] = useState<any>(undefined);
  const [groupNames, setGroupNames] = useState<any[]>([]);
  const [groupValue, setGroupValue] = useState<any>({
    employer_id: '',
    employer_name: '',
  });
  const [isAddGroupPopupOpen, setIsAddGroupPopupOpen] = useState<boolean>(
    false,
  );
  const [isDeleteGroupPopup, setIsDeleteGroupPopup] = useState<boolean>(false);
  const [deleteGroupData, setDeleteGroupData] = useState<any>({
    group_id: '',
    group_name: '',
  });
  // const [groupsLoading, setGroupsLoading] = useState<boolean>(false);
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  // const [toggleState, setToggleState] = useState('right');
  const [loading, setLoading] = useState<boolean>(true);
  // const [showSeeMore, setShowSeeMore] = useState<boolean>(false);
  const [
    columnIdForSubCategories,
    setColumnIdForSubCategories,
  ] = useState<string>();

  //Functions
  const handleCloseSnackBar = () => {
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const getAllCareNavGroups = async () => {
    const employerGroups = toJS(loginPageStore.userResponse)?.groups?.map(
      (item: any) => item.groupId,
    );
    return await axios.post(
      properties.aiqBaseUrl + properties.groupsBaseURL + properties.getGroups,
      {
        eg_nid_list: loginPageStore.isCareNavigator
          ? employerGroups
          : userDetailsStore.careNavigationGroups?.map((group) => group.egNid),
      },
    );
  };

  const getGroupNames = async () => {
    const employerGroups = toJS(employerGroupStore.allEmployerGroupsData)?.map(
      (item) => item.eg_nid,
    );
    return await axios.post(
      properties.aiqBaseUrl +
        properties.groupsBaseURL +
        properties.getGroupNames,
      {
        eg_nid_list: employerGroups,
      },
    );
  };

  const getEmployerGroups = async (employerGroups: String[]) => {
    const token = JSON.parse(localStorage.getItem('token-storage') as string)
      ?.access_token;

    await axios
      .post(properties.aiqBaseUrl + properties.dateFiltersURL, {
        headers: {
          Authorization: token,
        },
        eg_nids: employerGroups,
      })
      .then((res: { status: number; data: { data: any } }) => {
        if (res.status === 200) {
          employerGroupStore.setAllEmployerGroupsData(res?.data.data);
        }
      });
  };

  const apiCalls = async () => {
    // setGroupsLoading(true);
    setLoading(true);
    await Promise.all([getAllCareNavGroups(), getGroupNames()])
      .then((responses: any) => {
        responses.map((res: any) => {
          if (res?.status !== 200) {
            handleOpenSnackBar(res?.reason?.message, 'error', 6000);
          }
        });
        let careNavigatorEgNids: String[] = [];

        if (responses[0]?.status === 200) {
          careNavigatorEgNids = responses[0]?.data?.data?.map(
            (group: any) => group.eg_nid,
          );
          setCareNavigatorGroups(
            formatCareNavigatorData(responses[0]?.data?.data),
          );
          setPageCount(Math.ceil(responses[0]?.data?.data.length / pageSize));

          const isCareNavigator = loginPageStore.isCareNavigator;
          if (isCareNavigator) {
            getEmployerGroups(careNavigatorEgNids);
          }
        }

        if (responses[1]?.status === 200) {
          const filteredGroupNames = responses[1]?.data?.data?.filter(
            (group: any) => !careNavigatorEgNids.includes(group.employer_id),
          );
          setGroupNames(filteredGroupNames);
        }
      })
      .then(() => {
        setLoading(false);
        // setGroupsLoading(false);
      });
  };

  useEffect(() => {
    apiCalls();
  }, []);

  const handleOpenAddGroup = () => {
    setIsAddGroupPopupOpen(true);
  };

  const handleCloseAddGroup = () => {
    setIsAddGroupPopupOpen(false);
  };

  const handleDeleteGroup = async () => {
    if (!deleteGroupData.group_id) {
      return;
    }
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.groupsBaseURL +
          properties.deleteCareNavGroup,
        {
          group_id: deleteGroupData.group_id,
        },
      )
      .then((response) => {
        if (response.status === 200) {
          handleOpenSnackBar('Group deleted succesfully', 'success', 6000);
        }
        setIsDeleteGroupPopup(false);
        apiCalls();
      })
      .catch((error) =>
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000),
      );
  };

  const handleCloseDeleteGroup = () => {
    setIsDeleteGroupPopup(false);
  };

  const handleSave = async () => {
    let eg_nid = '';
    let existing;
    if (groupValue.employer_id) {
      eg_nid = groupValue.employer_id;
      existing = true;
    } else {
      eg_nid =
        groupValue.employer_name?.replace(' ', '_')?.toLowerCase() +
        '_' +
        getCurrentTimestamp();
      existing = false;
    }
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.groupsBaseURL +
          properties.createGroup,
        {
          group_name: groupValue.employer_name,
          eg_nid: eg_nid,
          existing: existing,
        },
      )
      .then((response) => {
        if (response.status === 200) {
          handleOpenSnackBar('Group Added succesfully', 'success', 6000);
        }
        setIsAddGroupPopupOpen(false);
        apiCalls();
      })
      .catch((error) =>
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000),
      );
  };

  const handleMenuOnClick = (menu: string, data: any) => {
    setDeleteGroupData(data);
    setIsDeleteGroupPopup(true);
  };

  // //Components
  // const CareNavigatorCards = () => {
  //   return (
  //     <Grid>
  //       {groupsLoading ? (
  //         <Loader />
  //       ) : (
  //         <Grid className={classes.cards}>
  //           {(filteredData ?? CareNavigatorsGroups)?.map(
  //             (item: any, index: number) => {
  //               // Show the first 5 cards initially
  //               if (index < 5 || showSeeMore) {
  //                 return (
  //                   <CareNavigatorGroupCard
  //                     title={item.title}
  //                     stats={item.stats}
  //                     careNavigators={item.careNavigators}
  //                     handleOnClick={() => handleEmployeerGroupCardClick(item)}
  //                     handleMenuOnClick={(menu: string) =>
  //                       handleMenuOnClick(menu, {
  //                         group_id: item.id,
  //                         group_name: item.title,
  //                       })
  //                     }
  //                     options={options}
  //                   />
  //                 );
  //               }

  //               // Show the "Show More" card if it's the 6th card (index === 5)
  //               if (index === 5 && !showSeeMore) {
  //                 return (
  //                   <Grid key={index} className={classes.seeMoreCard}>
  //                     <Button
  //                       variant="text"
  //                       color="primary"
  //                       label={messages.DASHBOARD.SHOW_ALL}
  //                       onClick={() => {
  //                         setShowSeeMore(true);
  //                       }}
  //                     />
  //                   </Grid>
  //                 );
  //               }

  //               return null; // Do not render anything by default for other conditions
  //             },
  //           )}
  //         </Grid>
  //       )}
  //     </Grid>
  //   );
  // };

  const updateUserAccess = (
    egNid: string,
    riskGroups: any[],
    complianceGroups: any[],
    careNavigationGroups: any[],
  ) => {
    if (userDetailsStore.userAccess || loginPageStore.isCareNavigator) {
      const riskRoutes =
        riskGroups?.find((group) => egNid === group.egNid)?.screens || [];
      const complianceRoutes =
        complianceGroups?.find((group) => egNid === group.egNid)?.screens || [];
      const careNavigationRoutes =
        careNavigationGroups?.find((group) => egNid === group.egNid)?.screens ||
        [];

      const {
        userFeatures,
        userAccessRoutes: formatedUserAccessibleRoutes,
      } = formatUserAccessRoutes(
        loginPageStore.isCareNavigator
          ? [...loginPageStore.userFeatures]
          : [
              ...(toJS(loginPageStore.userResponse)?.careNavigationScreens ||
                []),
              ...riskRoutes,
              ...complianceRoutes,
              ...careNavigationRoutes,
            ],
      );

      loginPageStore.addUserAccessRoutes(formatedUserAccessibleRoutes);
      loginPageStore.addUserFeatures(userFeatures);
      loginPageStore.setMemberIdentification(
        userFeatures?.includes(UserAccessConstants.MEMBER_IDENTIFICATION),
      );
    }
  };

  const handleEmployeerGroupCardClick = (data: any) => {
    const employerGroup = employerGroupStore.allEmployerGroupsData?.find(
      (item) => item.eg_nid === data.eg_nid,
    );

    if (employerGroup) {
      const employerGroupResponseData: IEmployerGroupResponseData = {
        _id: employerGroup._id,
        risk_status: employerGroup.risk_status,
        eg_nid: [employerGroup.eg_nid],
        employer_group_name: [employerGroup.employer_group_name],
        status: employerGroup.status,
        plan_start_month: employerGroup.plan_start_month,
        plan_end_month: employerGroup.plan_end_month,
        recent_plan_year: employerGroup.recent_plan_year,
        start_month: employerGroup.start_month,
        start_year: employerGroup.start_year,
        end_month: employerGroup.end_month,
        end_year: employerGroup.end_year,
        total_enrolles: employerGroup.total_enrolles,
        pmpm: employerGroup.pmpm,
        total_cost: employerGroup.total_cost,
        organization: employerGroup.organization,
        assigned_to: employerGroup.assigned_to,
        __v: employerGroup.__v,
        last_updated: employerGroup.last_updated,
        sic_code: employerGroup.sic_code,
        industry_type: employerGroup.industry_type,
        state: employerGroup.state,
        admin_and_premium_cost: employerGroup.admin_and_premium_cost,
        max_claim_date: employerGroup.max_claim_date,
        min_claim_date: employerGroup.min_claim_date,
        max_incurred_date: employerGroup.max_incurred_date,
        min_incurred_date: employerGroup.min_incurred_date,
        care_navigation_id: employerGroup.care_navigation_id,
        network_indicator_list: employerGroup.network_indicator_list,
        is_claims_present: employerGroup.is_claims_present,
      };

      employerGroupStore.setEmployerGroupResponseData(
        employerGroupResponseData,
      );
      employerGroupStore.setIsIndividualGroup(true);
      getSpecificDeductibleAmount(
        getDateFromMonthAndYear(
          employerGroup?.start_month,
          employerGroup?.recent_plan_year,
        ),
        getDateFromMonthAndYear(
          employerGroup?.end_month,
          employerGroup?.end_year,
          true,
        ),
        [data.eg_nid],
        employerGroupStore,
      );
    }

    careNavigatorStore.setGroupData(
      data.id,
      data.title,
      data.eg_nid,
      data.existing,
    );
    updateUserAccess(
      data.eg_nid,
      toJS(userDetailsStore.riskManagementGroups),
      toJS(userDetailsStore.complianceAssuranceGroups),
      toJS(userDetailsStore.careNavigationGroups),
    );
    navigate(CARE_NAVIGATOR);
    return;
  };

  const handlePageChange = (event: ChangeEvent<unknown>, page: number) => {
    setPage(page);
  };

  const handleSort = (event: any, column: any, item: any) => {
    const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
    const { sortColumnName } = column;
    if (!sortColumnName) {
      return;
    }

    const newList = CareNavigatorsGroups
      ? [...CareNavigatorsGroups].sort((a: any, b: any) => {
          if (a[sortColumnName] < b[sortColumnName]) {
            return -1 * sortOrder;
          } else if (a[sortColumnName] > b[sortColumnName]) {
            return 1 * sortOrder;
          }
          return 0;
        })
      : [];

    setCareNavigatorGroups(newList);
  };

  const handleHeaderMouseEnter = (column: any, setColumnId?: any) => {
    setColumnId(column?.id || column?.sortColumnName);
  };

  const handleHeaderMouseLeave = (setColumnId?: any) => {
    setColumnId('');
  };

  const getEmployerTableData = (
    employerGroupList: any[],
    currentPage: number,
  ) => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return employerGroupList.slice(startIndex, endIndex);
  };

  const CareNavigatorsTable = () => {
    return (
      <Grid>
        <BasicTable
          isFullTable
          width="100%"
          columns={individualGroupsTableColumns}
          rowsData={formatGroupsTableData(
            getEmployerTableData(
              (filteredData ?? CareNavigatorsGroups)!,
              page,
            )!,
            handleEmployeerGroupCardClick,
            handleMenuOnClick,
          )}
          columnId={columnIdForSubCategories}
          handleHeaderMouseEnter={(column: any) =>
            handleHeaderMouseEnter(column, setColumnIdForSubCategories)
          }
          handleHeaderMouseLeave={() =>
            handleHeaderMouseLeave(setColumnIdForSubCategories)
          }
          showOnHoverHeader={true}
          showPagination={true}
          pageCount={pageCount}
          handlePagination={handlePageChange}
          pageNumber={page}
          handleMenuItem={handleSort}
          progressBarIndex={3}
          blurTextStyle={{
            filter: 'blur(3px)',
          }}
        />
      </Grid>
    );
  };

  const handleSearch = (value: string) => {
    if (!value || value.length <= 2) {
      setFilteredData(undefined);
      return;
    }

    const filteredData = CareNavigatorsGroups.filter((group: any) => {
      return group?.title?.toLowerCase().includes(value.toLowerCase());
    });

    setPageCount(Math.ceil(filteredData?.length / pageSize));
    setFilteredData(filteredData);
  };

  const NoGroups = () => {
    return (
      <Grid className={classes.noGroups}>
        <GifWithLabels
          mainLabel={
            <Typography
              fontSize="16px"
              fontType="medium"
              lineHeight="24px"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
              className={classes.text}
            >
              {'No Groups Exist !'}
            </Typography>
          }
          subLabel={undefined}
          gifUrl={NoResults}
        />
      </Grid>
    );
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Grid className={classes.root}>
          <TextField
            placeholder={messages.DASHBOARD.SEARCH}
            height="44px"
            startAdornment={
              <SimpleSearch
                height="24px"
                width="24px"
                stroke={patientAccessTheme.palette.text.lowemphasis}
              />
            }
            onChange={(event: any) => handleSearch(event.target.value)}
            showStartAdornment={true}
            style={{ marginBottom: '24px', width: '100%' }}
          />
          {(filteredData ?? CareNavigatorsGroups)?.length > 0 ? (
            <CareNavigatorsTable />
          ) : filteredData?.length === 0 ? (
            <NoGroups />
          ) : (
            <NoComplianceAssurances
              title={messages.NO_DATA.TITLE}
              subTitle={messages.NO_DATA.SUB_TITLE}
              handleOnclick={handleOpenAddGroup}
            />
          )}
        </Grid>
      )}
      {isAddGroupPopupOpen && (
        <AddCareNavGroupModal
          open={isAddGroupPopupOpen}
          handleSave={handleSave}
          groupValueState={[groupValue, setGroupValue]}
          handleClose={handleCloseAddGroup}
          isSaveButtonDisabled={groupValue.employer_name === ''}
          groupNames={groupNames}
        />
      )}
      {isDeleteGroupPopup && (
        <DeleteGroupConfirmModal
          open={isDeleteGroupPopup}
          handleSave={handleDeleteGroup}
          handleClose={handleCloseDeleteGroup}
          groupName={deleteGroupData?.group_name}
        />
      )}
      <Snackbar
        {...snackbarState}
        vertical={'bottom'}
        horizontal={'right'}
        handleClose={handleCloseSnackBar}
      />
    </>
  );
});

export default CareNavigator;
